import { storyblokEditable } from '@storyblok/react'

export default ({ blok }) => {
    return (
        <div className="gray-block" {...storyblokEditable(blok)}>
            <h2 className="gray-subtitle">{blok.title}</h2>
            <p className="gray-text">{blok.text}</p>
        </div>
    )
}
